//@ts-check
import classNames from 'classnames';
import React from 'react';

import './DownloadIcon.scss';

/**
 * @typedef DownloadIconProps
 * @property {string} iconContent
 */
/** @type {import('~/types/React').ReactFC<DownloadIconProps>} */
const DownloadIcon = ({ className, iconContent, ...rest }) => {
	return (
		<div
			{...rest}
			className={classNames('download-icon', 'with-shadow-background', className)}
			dangerouslySetInnerHTML={{ __html: iconContent }}
		/>
	);
};

export default DownloadIcon;
